import React from 'react';
import ErrorPage from 'shared/components/ErrorPage/ErrorPage';

export default class Error500 extends React.Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <ErrorPage title="Server Error">
        Looks like Anagram API unavailable. Try to refresh the page.
      </ErrorPage>
    );
  }
}
